export enum EWebclientScriptType {
  HEAD = 'head', // Script to be placed in the <head> section
  GTM = 'gtm', // Google Tag Manager
}
